import {onAuthStateChanged, signInWithEmailAndPassword} from "firebase/auth";
import {SetStateAction} from "react";
import {auth} from "./firebaseConfig";


export const authListener = (setUser: SetStateAction<any>) => {
    return onAuthStateChanged(auth, (aUser) => {
        if (!aUser) {
            console.log("User not logged in.");
            setUser(false);
            return;
        }
        console.log("User logged in.");
        if (!aUser.email) {
            setUser(false);
            return;
        }
        setUser(true);
    });
};

export const login = async (credentials: {email: string, password: string}) => {
    return signInWithEmailAndPassword(auth, credentials.email, credentials.password);
};

export type RegistrationData = {
    email: string,
    passwordOne: string,
    instituteName: string,
    "address-line1": string,
    "address-line2": string,
    locality: string,
    postal_code: string,
    country: string,
    first_name: string,
    family_name: string
}
